import UniversalButton from "components/uiComponents/UniversalButton";
import "./DeleteColumnModal.scss";

const DeleteColumnModal = (props) => {
  return (
    <div className="delete-column-modal">
      <div className="delete-column-modal__container">
        <p className="delete-column-modal__title">Add function</p>

        <p className="delete-column-modal__text">
          Are you sure you want to delete column{" "}
          <span className="delete-column-modal__column-name">
            {props.columnName}
          </span> ?
        </p>
      </div>
      <div className="modal_btns">
        <UniversalButton
          type="button"
          label="Go back"
          size="lg"
          labelColor="blue"
          labelHoverColor="blue"
          backgroundColor="white"
          backgroundHoverColor="blue-light"
          onClick={props.onClose}
        />

        <UniversalButton
          type="button"
          label="Yes, delete"
          size="lg"
          onClick={props.deleteCallback}
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
        />
      </div>
    </div>
  );
};

export default DeleteColumnModal;
